import { Rect, Text } from 'react-konva';
import type { ChartDimensions } from './types';

/** Width of the quadrant label. */
const Q_LABEL_W = 100;
/** Height of the quadrant label. */
const Q_LABEL_H = 48;
/** Opacity of the quadrant label. */
const Q_LABEL_OPACITY = 0.1;

/** Quadrant colors — TBD. */
const Q_FILL = {
    topLeft: 'rgb(250,215,180)',
    topRight: 'rgb(219,202,242)',
    bottomLeft: 'rgb(241,187,163)',
    bottomRight: 'rgb(210,231,239)',
};

/** Radius of the rounded corners of the quadrant backgrounds. */
const CORNER_RADIUS = 8;

export type QuadrantsProps = {
    chartDimensions: ChartDimensions;
};

export function Quadrants({ chartDimensions }: QuadrantsProps) {
    const { xOrigin, yOrigin, left, top, width, height } = chartDimensions;

    return (
        <>
            <Rect
                x={left}
                y={top}
                width={width / 2}
                height={height / 2}
                fill={Q_FILL.topLeft}
                cornerRadius={[CORNER_RADIUS, CORNER_RADIUS, 0, CORNER_RADIUS]}
            />
            <Text
                x={left + width / 4 - Q_LABEL_W / 2}
                y={top + height / 4 - Q_LABEL_H / 2}
                width={Q_LABEL_W}
                height={Q_LABEL_H}
                text="改善"
                align="center"
                verticalAlign="middle"
                fontSize={Q_LABEL_H}
                fontStyle="bold"
                fill="#444"
                opacity={Q_LABEL_OPACITY}
                lineHeight={1}
            />
            <Rect
                x={xOrigin}
                y={top}
                width={width / 2}
                height={height / 2}
                fill={Q_FILL.topRight}
                cornerRadius={[CORNER_RADIUS, CORNER_RADIUS, CORNER_RADIUS, 0]}
            />
            <Text
                x={xOrigin + width / 4 - Q_LABEL_W / 2}
                y={top + height / 4 - Q_LABEL_H / 2}
                width={Q_LABEL_W}
                height={Q_LABEL_H}
                text="強み"
                align="center"
                verticalAlign="middle"
                fontSize={Q_LABEL_H}
                fontStyle="bold"
                fill="#444"
                opacity={Q_LABEL_OPACITY}
                lineHeight={1}
            />
            <Rect
                x={left}
                y={yOrigin}
                width={width / 2}
                height={height / 2}
                fill={Q_FILL.bottomLeft}
                cornerRadius={[CORNER_RADIUS, 0, CORNER_RADIUS, CORNER_RADIUS]}
            />
            <Text
                x={left + width / 4 - Q_LABEL_W / 2}
                y={yOrigin + height / 4 - Q_LABEL_H / 2}
                width={Q_LABEL_W}
                height={Q_LABEL_H}
                text="弱み"
                align="center"
                verticalAlign="middle"
                fontSize={Q_LABEL_H}
                fontStyle="bold"
                fill="#444"
                opacity={Q_LABEL_OPACITY}
                lineHeight={1}
            />
            <Rect
                x={xOrigin}
                y={yOrigin}
                width={width / 2}
                height={height / 2}
                fill={Q_FILL.bottomRight}
                cornerRadius={[0, CORNER_RADIUS, CORNER_RADIUS, CORNER_RADIUS]}
            />
            <Text
                x={xOrigin + width / 4 - Q_LABEL_W / 2}
                y={yOrigin + height / 4 - Q_LABEL_H / 2}
                width={Q_LABEL_W}
                height={Q_LABEL_H}
                text="注意"
                align="center"
                verticalAlign="middle"
                fontSize={Q_LABEL_H}
                fontStyle="bold"
                fill="#444"
                opacity={Q_LABEL_OPACITY}
                lineHeight={1}
            />
        </>
    );
}
